module.exports = __webpack_public_path__ + "static/Mindfulness-2-44c766fb3f2bb3c12602f95bd8abb337.png";